'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react/dist/focus-trap-react';
// Import JS Modules
import { getViewport } from './hoc/with-viewport-size';
// -----------------------------------------------------------
//  MobileFilter
// -----------------------------------------------------------
class MobileFullScreen extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  get visible() {
    let visible = this.props.open;

    if (this.props.smallScreenOnly) {
      visible = visible && getViewport().isMobile;
    }

    return !!visible;
  }

  get activateFocusTrap() {
    return this.visible;
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    const { className, children, fullWidth } = this.props;

    return (
      <FocusTrap active={this.activateFocusTrap}>
        <div className={classNames('mobile-full-screen', className, { 'd-none': !this.visible })}
             style={{ maxHeight: getViewport().height, ...this.props.extraStyles }}
             onClick={this.handleClick}
             onKeyDown={this.handleKeyDown}>
          <div className="interior">
            {this.renderHeader()}
            <section className={classNames(fullWidth ? 'container-fluid' : 'container')}>
              {children}
            </section>
          </div>
        </div>
      </FocusTrap>
    );
  }

  renderHeader() {
    const { noHeader } = this.props;

    if (noHeader) {
      return null;
    }

    return (
      <header className="container">
        <a href="#"
           className="back-button"
           onClick={this.handleBackClick}>
          &lt; Back
        </a>
      </header>
    );
  }

  handleBackClick = (e) => {
    e && e.preventDefault();

    if (typeof this.props.onBack == 'function') {
      this.props.onBack();
    }
  }

  handleClick = (e) => {
    if ($(e.target).closest('.interior').length === 0 && typeof this.props.onBack == 'function') {
      this.props.onBack();
    }
  }

  handleKeyDown = (e) => {
    if (this.props.open && e.keyCode === 27) {
      this.handleBackClick();
    }
  }
}

MobileFullScreen.displayName = 'MobileFullScreen';

export default MobileFullScreen;
